var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/app/search/directives/search-result-news/search-result-news.html',
    '<div class="news-item">\n' +
    '    <div class="news-item-left-block" ng-show="item.avatar.thumb_path" style="background-image: url(\'{{ item.avatar.thumb_path }}\');">\n' +
    '    </div>\n' +
    '    <div class="news-item-right-block">\n' +
    '        <div class="news-item-date">{{ item.created }}</div>\n' +
    '        <div class="news-item-name">\n' +
    '            <a href="{{ item.route_info }}" target="_blank" ng-bind-html="item.highlighted_title | rawHtml"></a>\n' +
    '        </div>\n' +
    '        <div class="news-item-author">{{ item.user.full_name }}</div>\n' +
    '        <div class="news-item-content" ng-bind-html="item.highlighted_text | rawHtml"></div>\n' +
    '        <div class="news-item-categories">\n' +
    '            <span class="news-item-category" ng-repeat="category in item.categories">\n' +
    '                <a href="{{ category.route_info }}" class="news-item-category-link">\n' +
    '                    {{ category.name }}\n' +
    '                </a>\n' +
    '                {{ $last ? \'\': \', \'}}\n' +
    '            </span>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

module.exports = "/app/search/directives/search-result-news/search-result-news.html";